import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInputComponent = ({ value, onChange, errorMessage }) => {
  return (
    <div className="form-group phone-input-container">
      <div className={`phone-input-wrapper ${errorMessage ? "error-input" : ""}`}>
        {value === "+1"}
        <PhoneInput
          country={"us"}
          value={value}
          onChange={(phone) => onChange(phone)}
          inputClass="phone-input"
          required
        />
      </div>
      {errorMessage && <div className="error-text">{errorMessage}</div>}
    </div>
  );
};

export default PhoneInputComponent;